<template>
  <div class="products">
    <v-card v-if="products.length == 0">
      <v-card-subtitle>
        <span><center>No existen productos que preparar</center></span>
      </v-card-subtitle>
    </v-card>
    <ProductsView v-bind:products="products" v-if="products.length > 0"></ProductsView>
  </div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import ProductsView from '../components/ProductsView'
import { DB } from '../firebase/db'

export default {
  name: 'products',

  props: ['date'],

  data: () => ({
      title: 'Productos',
      products: []
    }),

    components : {
      ProductsView
    },

    created() {
      this.$emit('updateTitle', this.title);
      this.getOrders();
    },

    watch : {
      date : function(date) {
        this.getOrders();
      }
    },

    methods: {
      getOrders : function() {
        let productsTemp = [];

        DB.collection('orders').where('date', '==', this.date).get()
        .then( snapshots => {
          snapshots.docs.forEach( docSnap => {
            productsTemp = productsTemp.concat(docSnap.data().products);
          })
          this.products = productsTemp;
        })
        .catch(error => {
          alert(error);
        })
      }
    }

}
</script>
